import { AreaBase } from './base/area-base';

export class Area extends AreaBase { }